// extracted by mini-css-extract-plugin
export default {"FullScreenFixed":"📚19-10-2fcqNB","fade_bottom":"📚19-10-2bRwdS","ActionbarOffset":"📚19-10-2y0RVm"};